import type { User, Item, SwapProposal, Rating } from "./types";

async function fetchJSON<T>(url: string, options?: RequestInit): Promise<T> {
	const res = await fetch(url, {
		headers: { "Content-Type": "application/json" },
		...options,
	});
	if (!res.ok) throw new Error(`API error: ${res.status}`);
	return res.json();
}

export const api = {
	users: {
		list: () => fetchJSON<User[]>("/api/users"),
		get: (id: string) => fetchJSON<User>(`/api/users/${id}`),
		getItems: (id: string) => fetchJSON<Item[]>(`/api/users/${id}/items`),
		getSwaps: (id: string) => fetchJSON<SwapProposal[]>(`/api/users/${id}/swaps`),
		addRating: (id: string, rating: Omit<Rating, "id" | "createdAt">) =>
			fetchJSON<Rating>(`/api/users/${id}/ratings`, {
				method: "POST",
				body: JSON.stringify(rating),
			}),
	},
	items: {
		list: () => fetchJSON<Item[]>("/api/items"),
		listAll: () => fetchJSON<Item[]>("/api/items/all"),
		get: (id: string) => fetchJSON<Item>(`/api/items/${id}`),
		create: (item: Omit<Item, "id" | "createdAt" | "available">) =>
			fetchJSON<Item>("/api/items", {
				method: "POST",
				body: JSON.stringify(item),
			}),
	},
	swaps: {
		list: () => fetchJSON<SwapProposal[]>("/api/swaps"),
		get: (id: string) => fetchJSON<SwapProposal>(`/api/swaps/${id}`),
		create: (swap: Omit<SwapProposal, "id" | "fairnessScore" | "createdAt" | "updatedAt" | "status">) =>
			fetchJSON<SwapProposal>("/api/swaps", {
				method: "POST",
				body: JSON.stringify(swap),
			}),
		updateStatus: (id: string, status: string) =>
			fetchJSON<SwapProposal>(`/api/swaps/${id}/status`, {
				method: "PUT",
				body: JSON.stringify({ status }),
			}),
	},
	fairness: {
		calculate: (offeredItems: string[], requestedItems: string[]) =>
			fetchJSON<{ score: number }>("/api/fairness", {
				method: "POST",
				body: JSON.stringify({ offeredItems, requestedItems }),
			}),
	},
};
